export default __webpack_public_path__ + "static/media/avatar_65.f54c7fed.png";